import React from 'react';
import PropTypes from 'prop-types';
import { LoadingSpinner } from 'components/common';
import PipelineStatusChart from 'components/app/crm/dashboard/sales/PipelineStatusChart';
import ConversionFunnelChart from 'components/app/crm/dashboard/sales/ConversionFunnelChart';
import TrendChart from 'components/app/crm/dashboard/sales/TrendChart';
import SalesUnitChart from 'components/app/crm/dashboard/sales/SalesUnitChart';
import OverviewDetailGrid from '../OverviewDetailGrid';

// PCV tab — full pipeline analytics: pipeline-stage distribution (canonical
// order), conversion funnel, monthly trend, and sales-unit / region breakdown.
// Pipeline (statuses) and funnel (funnel_stage) drills are honoured by the
// Overview detail endpoint.
const PcvTab = ({ data, loading, baseParams, onDrill, groupBy, onGroupByChange }) => {
  if (loading && !data) return <div className="tw-text-center tw-py-12"><LoadingSpinner /></div>;

  return (
    <>
      <div className="tw-mb-3">
        <PipelineStatusChart
          data={data?.pipeline}
          loading={loading}
          onDrillDown={(title, extra) => onDrill({ section: 'pcv', title, extraParams: extra })}
        />
      </div>

      <div className="tw-mb-3">
        <ConversionFunnelChart
          data={data?.funnel}
          loading={loading}
          subtitle="Project creation → Quotation → Negotiation → Job"
          onDrillDown={(title, extra) => onDrill({ section: 'pcv', title, extraParams: extra })}
        />
      </div>

      <div className="tw-mb-3">
        <TrendChart data={data?.trend} loading={loading} groupBy={groupBy} onGroupByChange={onGroupByChange} />
      </div>

      <div className="tw-mb-3">
        <SalesUnitChart data={{ by_region: data?.by_region, by_unit: data?.sales_unit }} loading={loading} />
      </div>

      <OverviewDetailGrid section="pcv" title="All Projects (PCV)" baseParams={baseParams} />
    </>
  );
};

PcvTab.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  baseParams: PropTypes.object.isRequired,
  onDrill: PropTypes.func.isRequired,
  groupBy: PropTypes.string,
  onGroupByChange: PropTypes.func
};
PcvTab.defaultProps = { data: null, loading: false, groupBy: 'month', onGroupByChange: () => {} };

export default PcvTab;
